import React, { useContext } from 'react';
import { Drawer } from '@mui/material';

import { AppContext } from '../../../app.context';
import { SidebarProps } from '../sidebar.type';
import {
  ImpersonationHint,
  LogoSection,
  NavigationSection,
} from '../components';

import {
  RootWrapper,
  SidebarWrapper,
  ContentWrapper,
} from './sidebar-desktop.style';

function SidebarDesktop({
  homePath,
  navigationSections,

  onNavigationLinkClick,
}: SidebarProps): JSX.Element {
  const { isSidebarOpen } = useContext(AppContext);

  return (
    <>
      <ImpersonationHint />
      <RootWrapper isSidebarOpen={isSidebarOpen}>
        <Drawer
          variant="permanent"
          sx={{
            '& .MuiDrawer-paper': {
              borderRight: 'none',
            },
          }}
        >
          <SidebarWrapper isSidebarOpen={isSidebarOpen}>
            <LogoSection isSidebarOpen={isSidebarOpen} homePath={homePath} />
            <ContentWrapper>
              <NavigationSection
                isSidebarOpen={isSidebarOpen}
                onNavigationLinkClick={onNavigationLinkClick}
                navigationSections={navigationSections}
              />
            </ContentWrapper>
          </SidebarWrapper>
        </Drawer>
      </RootWrapper>
    </>
  );
}

export { SidebarDesktop };
